export default "__VITE_ASSET__BgYtLDmY__"